import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17ecc0cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-bg" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "home-left" }
const _hoisted_4 = { class: "home-login" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "login-title" }, "用户登录", -1 /* HOISTED */))
const _hoisted_6 = { class: "login-content-others" }
const _hoisted_7 = { class: "login-content-btn" }

import { ref, reactive, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { loginUser, getBasicInfo } from '@/service/api/auth/index';
import { setRefreshToken, setToken, getRefreshToken } from '@/utils/storage';
import { AUTH_STORE } from '@/store';
import { getStore } from '@uds/pinia-manager';
import { UseIcon } from '@/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const userForm = reactive({
    account: '',
    password: '',
    remember7: false,
});
const showPass = ref(false);
const isLoading = ref(false);
const route = useRoute();
const router = useRouter();

const authStore = getStore(AUTH_STORE);

const jumpToRedirect = () => {
    // 登录成功，跳到转首页——如果是复制粘贴的路径，非首页/登录页，那么登录成功后重定向到对应的路径中
    if (!route.query.redirect) return;
    const redirect = decodeURIComponent(route.query.redirect as string);
    if (redirect.includes('http://') || redirect.includes('https://')) {
        // 判断原地址是否携带参数
        if (redirect.indexOf('?') !== -1) {
            window.open(`${redirect}&refreshToken=${getRefreshToken()}`, '_blank');
        } else {
            window.open(`${redirect}?refreshToken=${getRefreshToken()}`, '_blank');
        }
    }
};

// 登录
const signIn = async () => {
    const params = {
        userName: '',
        password: userForm.password,
        loginType: 0, // 0用户名密码 1手机 2邮箱
        tel: '',
        email: '',
        valiCode: '',
        refreshToken: '',
        authType: '',
    };
    if (/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(userForm.account)) {
        params.email = userForm.account;
    } else if (Number(userForm.account) && userForm.account.length === 11) {
        params.tel = userForm.account;
    } else {
        params.userName = userForm.account;
    }
    try {
        const {
            data: { accessToken, expiresIn, refreshToken },
        } = await loginUser(params);
        setToken(accessToken, expiresIn);
        setRefreshToken(refreshToken, userForm.remember7, expiresIn);
    } catch (error) {
        ElMessage.error(Error.prototype.toString.call(error));
        return;
    }

    jumpToRedirect();

    const { data } = await getBasicInfo();
    authStore.setUserInfo(data);
    await router.push('/home');
    ElMessage({
        message: '登录成功',
        type: 'success',
        duration: 5000,
    });
};

const onSignIn = () => {
    // 验证非空
    if (!userForm.account || !userForm.password) {
        ElMessage.error('账号不能为空');
        return;
    }
    // 全部校验通过，发送请求
    isLoading.value = true;
    signIn().finally(() => {
        isLoading.value = false;
    });
};

// 跳转页面
const goResetPass = () => {
    ElMessage.warning('请联系管理员重置密码');
};

const textFocus = ref(false);
const passFocus = ref(false);

const textIconShow = computed(() => {
    if (!textFocus.value) return false;
    return !!userForm.account;
});

const passIconShow = computed(() => {
    if (!passFocus.value) return false;
    return !!userForm.password;
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_form, {
          model: userForm,
          class: "login-content-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "account",
              class: "account-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  ref: "accIpt",
                  placeholder: "用户名/手机号/邮箱",
                  modelValue: userForm.account,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userForm.account) = $event)),
                  autocomplete: "off",
                  class: "account-item-ipt",
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (textFocus.value = true)),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (textFocus.value = false))
                }, {
                  suffix: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", {
                      class: "clear-icon",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (userForm.account = ''))
                    }, [
                      _createVNode(_unref(UseIcon), {
                        iconClass: "icon-close",
                        fontSize: 20,
                        class: "svg-icon"
                      })
                    ], 512 /* NEED_PATCH */), [
                      [_vShow, _unref(textIconShow)]
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              prop: "password",
              class: "account-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: showPass.value ? 'text' : 'password',
                  modelValue: userForm.password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userForm.password) = $event)),
                  placeholder: "请输入密码",
                  autocomplete: "new-password",
                  class: "account-item-ipt",
                  onFocus: _cache[6] || (_cache[6] = ($event: any) => (passFocus.value = true)),
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (passFocus.value = false))
                }, {
                  suffix: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", {
                      class: "pass-icon",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showPass.value = !showPass.value))
                    }, [
                      (showPass.value)
                        ? (_openBlock(), _createBlock(_unref(UseIcon), {
                            key: 0,
                            iconClass: "icon-password_show",
                            fontSize: 20,
                            class: "svg-icon"
                          }))
                        : (_openBlock(), _createBlock(_unref(UseIcon), {
                            key: 1,
                            iconClass: "icon-password_hide",
                            fontSize: 20,
                            class: "svg-icon"
                          }))
                    ], 512 /* NEED_PATCH */), [
                      [_vShow, _unref(passIconShow)]
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["type", "modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_checkbox, {
                modelValue: userForm.remember7,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((userForm.remember7) = $event)),
                label: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["checkbox-text", { 'is-checked': userForm.remember7 }])
                  }, " 7天内免登录 ", 2 /* CLASS */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]),
              _createElementVNode("a", {
                onClick: goResetPass,
                class: "forget-pass"
              }, "忘记密码？")
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                type: "primary",
                class: "login-content-submit",
                onClick: onSignIn,
                loading: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 登 录 ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model"])
      ])
    ])
  ]))
}
}

})